import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import Swal from "sweetalert2";
import $ from "jquery";
import { useNavigate, useParams } from "react-router-dom";
import { AddProjectModificationRequests } from "../../../Redux/Reducers/ReportStage/ProjectModificationRequests";
import { GetAlRequestType } from "../../../Redux/Reducers/ReportStage/Dropdowns/RequestType";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import { GetSpecificRowReport } from "../../../Redux/Reducers/ReportStage/Report";

const ProjectModificationRequestsForm = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userInfo = useSelector((state) => state.UserInfo.UserInfo);
  console.log(userInfo.userToken.userGuid, "userInfo");
  const DropDownRequestType = useSelector(
    (state) => state.DropDownRequestType.DropDownRequestType
  );

  const ProjectModificationRequests = useSelector(
    (state) => state.ProjectModificationRequests
  );

  const ReportRow = useSelector(
    (state) => state.ReportStatus?.ReportRow?.rS_ST_ReportStatus?.reportStatusId
  );

  console.log(userInfo.userToken.userGuid, "userInfo");
  console.log(ProjectModificationRequests, "ProjectModificationRequests");

  useEffect(() => {
    dispatch(GetAlRequestType());
  }, []);

  const [RequestTypeId, setRequestTypeId] = useState("");
  const [ReportStatusId, setReportStatusId] = useState("");
  const [ProjectModificationValidation, setProjectModificationValidation] =
    useState(false);

  // Fetch existing activity on edit

  const Validation = () => {
    const isEmpty = !RequestTypeId || RequestTypeId.trim() === "";
    setProjectModificationValidation(isEmpty);
    return !isEmpty;
  };

  const Add = () => {
    if (Validation()) {
      dispatch(
        AddProjectModificationRequests({
          reportId: props.reportId,
          creationUserGUID: userInfo.userToken.userGuid,
          requestOpeningDate: new Date().toISOString(),
          requestTypeId: RequestTypeId,
          requestClosingDate: null,
          //   reportStatusId: ReportStatusId,
        })
      );

      Swal.fire({
        position: "center",
        icon: "success",
        title: "تمت الأضافة بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });

      $(".close-btn").trigger("click");
    }
  };

  return (
    <>
      <AllDropDownsAHSF
        fieldsName="RequestType"
        show={true}
        // disabled={shouldDisableFields}
        KeyText={"requestType"}
        KeyValue={"requestTypeId"}
        arrayOoptionList={DropDownRequestType}
        dropdownType={"normal"}
        onChange={(e) => {
          setRequestTypeId(e.target.value);
        }}
        // defaultValue={OtherSupport?.supportTypeId}
        showValidationMessage={ProjectModificationValidation}
        validationMessage="يرجى تعبئة هذا الحقل"
      />

      <div className="ConainerButtonAHSF">
        <ButtonAHSF onClick={Add} text="حفظ" show={true} />
      </div>
    </>
  );
};

export default ProjectModificationRequestsForm;
